import { z } from "zod";
import { adminActionKindSchema } from "./admin-operations-actions.js";
import { adminSubjectTypeSchema } from "./admin-operations-cases.js";
import { adminOperationsExtendedSchemaVersionSchema, adminRoleSchema, adminSafeIdentifierSchema, adminUlidSchema, } from "./admin-operations-core.js";
const waiting = {
    id: adminUlidSchema,
    requestedBy: z.string().min(1).max(128),
    requestedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    /** False when the signed-in owner asked for it or is its subject: someone else approves it. */
    canApprove: z.boolean(),
};
/**
 * Everything waiting on a second owner (stage 2, 2026-11-02), newest first: protected actions
 * (voucher revocation, account erasure and the other high-impact reviews), access requests and
 * break-glass requests. Expired and already approved ones are left out. A protected-action review
 * prepared before this list existed carries no index entry and is not listed; it is still opened
 * by its reference.
 */
export const adminPendingApprovalSchema = z.discriminatedUnion("kind", [
    z
        .object({
        kind: z.literal("PROTECTED_ACTION"),
        ...waiting,
        action: adminActionKindSchema,
        subjectType: adminSubjectTypeSchema,
        subjectId: adminSafeIdentifierSchema,
    })
        .strict(),
    z
        .object({
        kind: z.literal("ACCESS_REQUEST"),
        ...waiting,
        change: z.enum(["GRANT", "DISABLE"]),
        operatorId: z.string().min(1).max(128),
        roles: z.array(adminRoleSchema).max(adminRoleSchema.options.length),
    })
        .strict(),
    z
        .object({
        kind: z.literal("BREAK_GLASS"),
        ...waiting,
        operatorId: z.string().min(1).max(128),
        incidentId: adminSafeIdentifierSchema,
    })
        .strict(),
]);
export const adminPendingApprovalsResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsExtendedSchemaVersionSchema,
        approvals: z.array(adminPendingApprovalSchema).max(50),
        /** More were waiting than one answer lists. */
        truncated: z.boolean(),
        checkedAt: z.string().datetime(),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-approvals.js.map